import React, { useState } from "react";
import { Pen } from "lucide-react";
import ToggleSwitch from "../../../ui/ToggleSwitch";
import CustomModal from "../../../ui/CustomModal";
import UpdateVariantForm from "../form/UpdateVariantForm";
import { Variant } from "../../../../types/modules/product.type";
import i18next from "i18next";
import { useUpdateResource } from "../../../../hooks/useUpdateResource";
import { useParams } from "react-router-dom";
import { formatNumber } from "../../../../utils/formatNumber";
import { PermissionGate } from "../../../admin/PermissionGate";
import { PermissionsKey } from "../../../../data/permissions";


type Props={
  variantItem:Variant,
  isColor:boolean,
  categoryId:number
}

function VariantBox({variantItem,isColor,categoryId}:Props) {
    const [isOpen, setIsOpen] = useState(false);
    const enName = variantItem.languages.find(s=>s.languageCode==="en")?.name ||"";
    const arName = variantItem.languages.find(s=>s.languageCode==="ar")?.name ||"";

    const { storeId} = useParams<{ productId: string ,storeId:string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;

    const [isActive, setIsActive]= useState(variantItem.isActive);
    const {updateResource} = useUpdateResource();


    async function handleChangeActive(){
      setIsActive(p=>!p);
      const endPoint =  numericStoreId ? `product-variant/active/${variantItem.id}?storeId=${numericStoreId}` : `product-variant/active/${variantItem.id}`;
      await  updateResource(endPoint, {}, numericStoreId ? "admin" : "store",{
          method: "PUT",
          invalidateQueries:["product-detail"],
    });
    }
    
  return (
    <div className="flex items-center justify-between py-4 w-[330px]">
      {/* Left side: Image + Title + Price */}
      <div className="flex items-center gap-4">
        {/* Image */}
        {
          variantItem.imageUrl&&
          <div className="w-[82px] h-[64px] bg-gray-200 flex items-center justify-center rounded-md">
            <img
              src={variantItem.imageUrl}
              alt="Variant"
              className="w-[82px] h-[64px] object-cover rounded-md"
            />
        </div>
        }

        {/* Title + Price */}
        <div className="flex flex-col">
          {
            isColor
            ?
            <span 
            style={{backgroundColor:variantItem.languages[0].name}}
            className={`block w-6 h-6 rounded-full`}/>
            :
          <h3 className="font-medium text-sm text-Black">{variantItem.languages.find(vI=>vI.languageCode===i18next.language)?.name}</h3>
          }
          <div className="flex gap-1 items-center">
            <img src="/Vector2.png" alt="" className="w-[10.67px] h-[11.95px]"/>
            <p className="text-Black text-[16px] font-black">{formatNumber(variantItem.additionalPrice)}</p>
          </div>
        </div>
      </div>

      {/* Right side: Edit + Toggle */}
      <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
          <div className="flex items-center gap-3">
          <button 
          onClick={()=>setIsOpen(true)}
          className="text-primaryButton hover:underline flex items-center gap-1">
            <Pen size={16} />
          </button>
          <ToggleSwitch checked={isActive} onChange={handleChangeActive} size="sm" />
        </div>
      </PermissionGate>
      <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Update Variant"
        >
    <UpdateVariantForm
        initialValues={{
           additional_price: variantItem.additionalPrice,
            categoryId: categoryId, // optional initial category
            languages: [
            { languageCode: 'en', name: enName},
            { languageCode: 'ar', name: arName }
            ],
            image:variantItem.imageUrl
            }}
        onSubmitSuccess={() => setIsOpen(false)}
        id={variantItem.id}
        storeId={numericStoreId}
    />
    </CustomModal>

    </div>
  );
}

export default VariantBox;
